module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('h4', [_vm._v("Please contact ColonyLive sales team to activate this feature.")]), _vm._v(" "), _c('div', {
    staticClass: "mail-container"
  }, [_c('a', {
    staticClass: "mail-to-link",
    attrs: {
      "href": _vm.mailToSales
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v("\n      Contact Sales\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0108c544","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/common/ContactSales.vue
// module id = 3113
// module chunks = 3